import React from 'react';
import { Link } from 'react-router-dom';
import './IndustriesSection.scss';

const IndustriesSection = () => {
  const industries = [
    {
      name: 'Ecommerce',
      description: 'Implement a specialized ecommerce chatbot into your online sales strategy for intelligent, automated, and improved customer service.',
      icon: 'cart-icon.svg',
      path: '/solutions/ecommerce'
    },
    {
      name: 'Insurance',
      description: 'Transform your organization\'s efficiency and communicate with customers more effectively with our AI.',
      icon: 'settings.svg',
      path: '/solutions/insurance'
    },
    {
      name: 'Healthcare',
      description: 'With our conversational AI healthcare chatbots, your organization can operate more efficiently and deal with a greater volume of patients.',
      icon: 'mind-icon.svg',
      path: '/solutions/healthcare'
    },
    {
      name: 'Customer Service',
      description: 'Improve your customer outcomes with help of a specialized AI customer support chatbot.',
      icon: 'headset.svg',
      path: '/solutions/customer-service'
    },
    {
      name: 'Retail',
      description: 'Upgrade your organization\'s efficiency, with automated retail chatbots.',
      icon: 'lightbulb.svg',
      path: '/solutions/retail'
    },
    {
      name: 'Banking',
      description: 'Employ a conversational AI banking chatbot from Skil.AI to boost the efficiency.',
      icon: 'globe.svg',
      path: '/solutions/banking'
    },
    {
      name: 'Telecom',
      description: 'Upgrade to AI for customer service to enhance your customer experience.',
      icon: 'smartphone.svg',
      path: '/solutions/telecom'
    },
    {
      name: 'Real Estate',
      description: 'Automate the attraction and conversion of leads with a specialized real estate chatbot.',
      icon: 'home-icon.svg',
      path: '/solutions/real-estate'
    },
    {
      name: 'Email Automation',
      description: 'Leverage the power of artificial intelligence chatbots to automate your email strategy.',
      icon: 'email-icon.svg',
      path: '/solutions/email-automation'
    },
    {
      name: 'AI Recruiters',
      description: 'Make use of a new generation of AI for recruitment to cost-effectively improve your recruitment outcomes.',
      icon: 'brain.svg',
      path: '/solutions/ai-recruiting'
    }
  ];

  return (
    <section className="industries section">
      <div className="container">
        <h2 className="industries__title">INDUSTRIES</h2>
        <p className="industries__subtitle">
          Skil.AI's conversational chatbot technology is flexible and can be applied to any industry, including:
        </p>
        <div className="industries__grid">
          {industries.map((industry, index) => (
            <Link
              key={index}
              to={industry.path}
              className="industries__card"
            >
              <div className="industries__icon">
                <img
                  src={require(`../assets/images/${industry.icon}`)}
                  alt={industry.name}
                />
              </div>
              <h3 className="industries__name">{industry.name}</h3>
              <p className="industries__description">{industry.description}</p>
            </Link>
          ))}
        </div>
        <div className="industries__cta">
          <Link to="/solutions" className="button button--primary">
            Learn More
          </Link>
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection; 
